import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style", "animate", "onClose", "closeOptions", "isOpen", "children", "className", "fullWidthContent", "actionBarNode", "overlayRef", "disableOutsideClickHandler"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { cnBem, combineRefs } from '@carnica/utils';
import React, { forwardRef, useRef } from 'react';
import { useOnClickOutside } from "../hooks/useClickOutside";
import styles from "./styles.pcss";
var cnModalContent = cnBem('modal-content', styles);
export var ModalContent = /*#__PURE__*/forwardRef(function (props, ref) {
  var style = props.style,
    animate = props.animate,
    onClose = props.onClose,
    closeOptions = props.closeOptions,
    isOpen = props.isOpen,
    children = props.children,
    className = props.className,
    fullWidthContent = props.fullWidthContent,
    actionBarNode = props.actionBarNode,
    overlayRef = props.overlayRef,
    disableOutsideClickHandler = props.disableOutsideClickHandler,
    otherProps = _objectWithoutProperties(props, _excluded);
  var containerRef = useRef(null);
  useOnClickOutside({
    ref: containerRef,
    handler: !disableOutsideClickHandler ? onClose : undefined,
    isOpen: isOpen,
    overlayRef: overlayRef
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: cnModalContent({
      animate: animate,
      withCloseButton: !!onClose,
      fullWidthContent: fullWidthContent
    }, [className]),
    ref: combineRefs([containerRef, ref]),
    style: _objectSpread(_objectSpread({}, style), {}, {
      // Нужно чтоб несколько модалок точно нормально отрисовывались друг над другом
      zIndex: undefined
    })
  }), actionBarNode && /*#__PURE__*/React.createElement("div", {
    className: cnModalContent('action-bar')
  }, actionBarNode), /*#__PURE__*/React.createElement("div", {
    className: cnModalContent('wrapper')
  }, children));
});